module.exports = __webpack_public_path__ + "static/img/produto_p.334b549.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/spremidos-citrus/produto_p.png
// module id = jKPf
// module chunks = 0